/* VELBENT — interacciones ligeras (sin dependencias) */
(function () {
  'use strict';

  function initBeforeAfter(root) {
    var afterEl = root.querySelector('.vb-ba__after');
    var handle = root.querySelector('.vb-ba__handle');
    var range = root.querySelector('.vb-ba__range');
    if (!afterEl || !handle) return;

    function setPosition(percent) {
      percent = Math.max(0, Math.min(100, percent));
      afterEl.style.width = percent + '%';
      handle.style.left = percent + '%';
    }

    if (range) {
      range.addEventListener('input', function (e) {
        setPosition(parseFloat(e.target.value));
      });
    }

    var dragging = false;

    function percentFromClientX(clientX) {
      var rect = root.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    root.addEventListener('pointerdown', function (e) {
      dragging = true;
      setPosition(percentFromClientX(e.clientX));
      if (range) range.value = percentFromClientX(e.clientX);
    });

    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      setPosition(percentFromClientX(e.clientX));
      if (range) range.value = percentFromClientX(e.clientX);
    });

    window.addEventListener('pointerup', function () {
      dragging = false;
    });
  }

  function init() {
    document.querySelectorAll('[data-vb-before-after]').forEach(initBeforeAfter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-vb-before-after]');
    if (el) initBeforeAfter(el);
  });
})();
